import { render } from "./WashListTableMobile.vue?vue&type=template&id=78eece6f"
import script from "./WashListTableMobile.vue?vue&type=script&lang=ts"
export * from "./WashListTableMobile.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QIcon});
